import { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import api from "@/lib/api";

export function NotificationBell() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, []);
  const unread = items.filter((n) => !n.read).length;
  const markRead = async (n) => { if (!n.read) await api.post(`/notifications/${n.id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="notif-bell" className="relative w-10 h-10 rounded-xl flex items-center justify-center text-purple-200 hover:text-white hover:bg-[#1E0A3E] transition-colors">
          <Bell size={19} />
          {unread > 0 && <span data-testid="notif-bell-count" className="absolute top-0.5 right-0.5 min-w-[17px] h-[17px] px-1 rounded-full bg-[#FF2A6D] text-white text-[10px] font-bold flex items-center justify-center">{unread > 9 ? "9+" : unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-[#180735] border-[#2E1256] text-white">
        <div className="px-4 py-3 border-b border-[#2E1256] flex items-center justify-between">
          <span className="font-semibold text-sm">Notifications</span>
          {unread > 0 && <button onClick={markAll} data-testid="bell-mark-all" className="text-[11px] text-[#FF6B7D] hover:underline">Mark all read</button>}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {!items.length ? <div className="p-6 text-center text-sm text-purple-400/70">No notifications</div> :
            items.slice(0, 8).map((n) => (
              <button key={n.id} onClick={() => markRead(n)} data-testid={`bell-item-${n.id}`}
                className={`w-full text-left px-4 py-3 border-b border-[#230948] hover:bg-[#1E0A3E] transition-colors ${n.read ? "" : "bg-[#1E0A3E]/60"}`}>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-white">{n.title}</span>
                  {!n.read && <span className="w-1.5 h-1.5 rounded-full bg-[#FF2A6D]" />}
                </div>
                <div className="text-xs text-purple-300/80 mt-0.5 line-clamp-2">{n.body}</div>
              </button>
            ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
